import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const ETTMakeAttemptUI = (props: UIProperties<ETTMakeAttemptUIConfig>) => {
	const [isDLClicked, setIsDLClicked] = useState(true);
	const [isVLClicked, setIsVLClicked] = useState(false);
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				bottom: '20px',
				left: '50%',
				transform: 'translate(-50%, 0)',
				width: '630px',
				height: '170px',
				pointerEvents: 'all'
			}}>
				<img style={{
					width: '100%',
					height: '50px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '627px',
					height: '50px',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '20pt',
						textAlign: 'center',
						position: 'relative',
						top: '9px'
					}} className="title-font" tabIndex={0} id='ett-make-attempt-top'>Choose your tool and select "Make Attempt".</p>
				</div>

				<div style={{
					width: '100%',
					height: '118px',
					position: 'absolute',
					top: '50px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>
					<CustomMakeAttemptButton 
						foregroundImg='./assets/images/make-attempt/DL.png'
						showYellowThingyOnTheSide={isDLClicked}
						width= '140px'
						text='DL'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '7px',
							left: '60px'
						}}
						onClicked={() => {
							setIsDLClicked(true);
							setIsVLClicked(false);
						}}/>

					{!props.parameters.hideVlButton ? <CustomMakeAttemptButton 
						foregroundImg='./assets/images/make-attempt/VL.png'
						showYellowThingyOnTheSide={isVLClicked}
						width= '140px'
						text='VL'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '7px',
							left: '270px'
						}}
						customForegroundImageStyle={{
							height: '60px'
						}}
						onClicked={() => {
							setIsDLClicked(false);
							setIsVLClicked(true);
						}}/> : (null)}
					<CustomMakeAttemptButton 
						foregroundImg='./assets/images/Toolbag/icon_ett.png'
						showYellowThingyOnTheSide={true}
						width= '140px'
						text={'ETT ' + props.parameters.ettSize}
						isDisabled={true}
						position= {{
							type: 'absolute', 
							top: '7px',
							left: '450px'
						}}
						onClicked={() => {
						}}/>					
				</div>
				<GeneralButtonWithText parameters= {{
					text: 'Make Attempt',
					ariaLbl: 'Make attempt',
					top: '0px',
					left: '623px',
					width: '130px',
					isDisabled: false,
					srcIdle: "./assets/images/make-attempt/button_make_attempt_main.png",
					srcHighlight: "./assets/images/make-attempt/button_make_attempt_down.png",
					srcDisabled: null,
					highlightOnHover: true,
					customImgStyle: {
					},
					customButtonStyle : {
					},
					customTextStyle: {
						fontSize: '10pt',
						fontWeight: 'bold',
						top: '80px'
					},
					onClicked: () => {
						props.parameters.onMakeAttemptClicked(isDLClicked, isVLClicked);
					}
				}}/>
				<GeneralButtonWithText parameters= {{
					text: 'Abort Attempt',
					top: '102px',
					left: '623px',
					width: '130px',
					isDisabled: false,
					srcIdle: "./assets/images/main-menu/button_menu_exit.png",
					srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
					highlightOnHover: true,
					srcDisabled: null,
					ariaLbl: 'Abort Attempt',
					id: 'ett-make-attempt-bottom',
					customImgStyle: {
					},
					customButtonStyle : {
					},
					customTextStyle: {
						fontSize: '10pt',
						fontWeight: 'normal'
					},
					onClicked: () => {
						props.parameters.onAbortedClicked();
					}
				}}/>
			</div>
		</div>
	);

};

const CustomMakeAttemptButton = (props: CustomETTMakeAttemptButtonConfig) => {
	return (
		<div style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: props.width,
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					text: '',
					top: '0px',
					left: '0px',
					ariaLbl: props.text,
					isDisabled: props.isDisabled,
					width: props.width,
					srcIdle: './assets/images/general/buttons/button_side_large-1.png',
					srcHighlight: null,
					srcDisabled: './assets/images/general/buttons/button_side_large-1.png',
					customMainStyle: {
						// position: 'relative',
						// width: props.isFlipped ? '99px' : '129px',
						// transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
					},
					onClicked: () => {
						if(props.onClicked) {
							props.onClicked();
						}
					}
				}}/>
				<div style={{
						position: 'relative',
						top: '13px',
						height: 'calc(calc(' + props.width+'/2)-3px)',
						pointerEvents: 'none',
				}}>
					{props.foregroundImg ? <img style={{
						position: 'relative',
						top: '0',
						left: '50%',
						transform: 'translate(-50%, 0)',
						width: 'calc(' + props.width+'/2)',
						...props.customForegroundImageStyle
					}} src={props.foregroundImg} /> : (null)}
				</div>
				
				<div style={{
					position: 'absolute',
					height: '19px',
					pointerEvents: 'none',
					width: '70%',
					left: '12px',
					// top: props.text === 'Tool Bag' ? '69px' : undefined
				}}>
					<div style={{
						position: 'relative',
						top: '0'
					}}>
						<p className='title-font' style={{
							textAlign: 'right',
							margin: '0',
							fontSize: '8pt',
							fontWeight: 'normal'
						}}>{props.text}</p>
					</div>
					
				</div>

				{props.showYellowThingyOnTheSide ? (
					<img style={{
						position: 'absolute',
						top: 0,
						right: '-21px',
						width: '28px',
						pointerEvents: 'none'
					}} src="./assets/images/general/buttons/button_side_pointer.png" />
				) : (null)}
			</div>
		</div>
	);

};

interface CustomETTMakeAttemptButtonConfig {
	text: string;
	width: string;
	customForegroundImageStyle?: any;
	position: CustomETTMakeAttemptButtonPosition;
	foregroundImg: string;
	showYellowThingyOnTheSide?: boolean;
	isDisabled?: boolean;
	onClicked: () => void;
}

interface CustomETTMakeAttemptButtonPosition {
	type?: any;
	left: string;
	top: string;
}

export interface ETTMakeAttemptUIConfig extends BaseConfig{
	ettSize: string;
	hideVlButton?: boolean;
	onAbortedClicked: () => void;
	onMakeAttemptClicked: (isDLClicked: boolean, isVLClicked: boolean) => void;
}

export default ETTMakeAttemptUI;